
"use strict";

import * as THREE from "three";

class ShootGeometry extends THREE.BufferGeometry {

    static Cache = new Map<string, ShootGeometry>();

    lengthSegments: number;
    widthSegments: number;
    path: THREE.Curve<THREE.Vector3>;

    frames: {
        tangents: THREE.Vector3[];
        normals: THREE.Vector3[];
        binormals: THREE.Vector3[];
    };

    // Growth

    growing: boolean;
    startTime: number;
    endTime: number;

    constructor(preset: ShootPreset) {

        super();

        const defaultPreset: ShootPreset = {
            shootCount: 8,

            maxWidth: 1,
            maxHeight: 1,
            maxLength: 1,

            lengthSegments: 4,
            widthSegments: 4,

            pathFunction: () => {
                let path = new THREE.CatmullRomCurve3([
                    new THREE.Vector3(0, 0, 0),
                    new THREE.Vector3(1, 0, 0),
                ],
                    false, "catmullrom", .5
                );

                return path;
            },

            getNormalOffset:
                (lengthProgress, widthProgress) => {
                    return 1;
                },

            getBinormalOffset:
                (lengthProgress, widthProgress) => {
                    return 0;
                },
            getTangentOffset:
                (lengthProgress, widthProgress) => {
                    return 0;
                },
        };
        preset = { ...defaultPreset, ...preset };


        this.type = 'ShootGeometry';


        // this.width = 1 + Math.random() * 3;

        // this.path = new THREE.CatmullRomCurve3([
        //     new THREE.Vector3(0, 0, 0),
        //     new THREE.Vector3(.25, .1, 0),
        //     new THREE.Vector3(this.width / 2., 2 + (Math.random() * 2), 0),
        //     new THREE.Vector3(this.width, 1 + (Math.random() * 4), 0)
        // ],
        //     false, "catmullrom", .5
        // );

        this.path = preset.pathFunction();
        this.frames = this.path.computeFrenetFrames(preset.lengthSegments, false);

        const vertices = [];
        const uvs = [];
        const normals = [];
        const indices = [];
        const origins = [];
        const colors = [];

        let currentVertex = new THREE.Vector3();
        let currentPoint = new THREE.Vector3();

        for (let i = 0; i <= preset.lengthSegments; i++) {
            const normal = this.frames.normals[i];
            const binormal = this.frames.binormals[i];
            const tangent = this.frames.tangents[i];

            const lengthProgress = i / preset.lengthSegments;
            //console.log(lengthProgress);

            currentPoint = this.path.getPointAt(i / preset.lengthSegments, currentPoint);


            // let width = preset.maxWidth * preset.getNormalOffset(lengthProgress);
            //  let height = -.2 * Math.sin((1 - progress) * Math.PI);


            // Left
            for (let j = preset.widthSegments - 1; j >= 0; j--) {
                let widthProgress = j / (preset.widthSegments - 1);

                let normalOffset = preset.maxWidth * preset.getNormalOffset(lengthProgress, widthProgress);
                let binormalOffset = preset.maxHeight * preset.getBinormalOffset(lengthProgress, widthProgress);
                let tangentOffset = preset.maxLength * preset.getTangentOffset(lengthProgress, widthProgress);

                currentVertex.x = currentPoint.x - (normalOffset * normal.x) + (binormal.x * binormalOffset) + (tangent.x * tangentOffset);
                currentVertex.y = currentPoint.y - (normalOffset * normal.y) + (binormal.y * binormalOffset) + (tangent.y * tangentOffset);
                currentVertex.z = currentPoint.z - (normalOffset * normal.z) + (binormal.z * binormalOffset) + (tangent.z * tangentOffset);

                vertices.push(currentVertex.x, currentVertex.y, currentVertex.z);
                // normals.push(binormal.x, binormal.y, binormal.z);
                origins.push(currentPoint.x, currentPoint.y, currentPoint.z);
                uvs.push((1 - widthProgress) / 2, lengthProgress);
                colors.push(0, 1, 0);
            }

            // Center
            {
                let normalOffset = preset.maxWidth * preset.getNormalOffset(lengthProgress, 0);
                let binormalOffset = preset.maxHeight * preset.getBinormalOffset(lengthProgress, 0);
                let tangentOffset = preset.maxLength * preset.getTangentOffset(lengthProgress, 0);

                currentVertex.x = currentPoint.x + (normalOffset * normal.x) + (binormal.x * binormalOffset) + (tangent.x * tangentOffset);
                currentVertex.y = currentPoint.y + (normalOffset * normal.y) + (binormal.y * binormalOffset) + (tangent.y * tangentOffset);
                currentVertex.z = currentPoint.z + (normalOffset * normal.z) + (binormal.z * binormalOffset) + (tangent.z * tangentOffset);

                vertices.push(currentVertex.x, currentVertex.y, currentVertex.z);
                // normals.push(binormal.x, binormal.y, binormal.z);
                origins.push(currentPoint.x, currentPoint.y, currentPoint.z);
                uvs.push(.5, lengthProgress);
                colors.push(0, 0, 1);
            }


            // Right
            for (let j = 0; j <= preset.widthSegments - 1; j++) {
                let widthProgress = j / (preset.widthSegments - 1);

                let normalOffset = preset.maxWidth * preset.getNormalOffset(lengthProgress, widthProgress);
                let binormalOffset = preset.maxHeight * preset.getBinormalOffset(lengthProgress, widthProgress);
                let tangentOffset = preset.maxLength * preset.getTangentOffset(lengthProgress, widthProgress);

                currentVertex.x = currentPoint.x + (normalOffset * normal.x) + (binormal.x * binormalOffset) + (tangent.x * tangentOffset);
                currentVertex.y = currentPoint.y + (normalOffset * normal.y) + (binormal.y * binormalOffset) + (tangent.y * tangentOffset);
                currentVertex.z = currentPoint.z + (normalOffset * normal.z) + (binormal.z * binormalOffset) + (tangent.z * tangentOffset);

                vertices.push(currentVertex.x, currentVertex.y, currentVertex.z);
                // normals.push(binormal.x, binormal.y, binormal.z);
                origins.push(currentPoint.x, currentPoint.y, currentPoint.z);
                uvs.push(.5 + widthProgress / 2, lengthProgress);
                colors.push(1, 0, 0);
            }

        }
        //console.log(vertices);

        // Triangles.

        for (let i = 0; i < preset.lengthSegments; i++) {

            let span = preset.widthSegments * 2 + 1;
            let offset = preset.widthSegments;

            let centerPoint = (i * span) + offset;
            let nextCenterPoint = ((i + 1) * span) + offset;

            // left 
            for (let j = 0; j < preset.widthSegments; j++) {
                let a = centerPoint - j;
                let b = a - 1;
                let c = nextCenterPoint - j;
                let d = c - 1;

                indices.push(a, b, c); // face one
                indices.push(d, c, b); // face two
            }

            // right
            for (let j = 0; j < preset.widthSegments; j++) {
                let a = centerPoint + j;
                let b = a + 1;
                let c = nextCenterPoint + j;
                let d = c + 1;

                indices.push(c, b, a); // face one
                indices.push(b, c, d); // face two
            }

        }

        this.setIndex(indices);
        this.setAttribute('position', new THREE.Float32BufferAttribute(vertices, 3));
        this.setAttribute('uv', new THREE.Float32BufferAttribute(uvs, 2));
        // this.setAttribute('normal', new THREE.Float32BufferAttribute(normals, 3));
        this.setAttribute('origin', new THREE.Float32BufferAttribute(origins, 3));
        this.setAttribute('color', new THREE.Float32BufferAttribute(colors, 3));

        this.computeVertexNormals();

        // this.grow();
    }

    // grow() {
    //     this.growing = true;
    //     this.startTime = Date.now();
    //     this.endTime = this.startTime + 2000;// + (Math.random() * 3000);
    // }

    // update(time) {
    //     if (this.growing) {
    //         let progress = (Date.now() - this.startTime) / (this.endTime - this.startTime);
    //         let step = Math.floor(progress * 33);
    //         this.setDrawRange(0, step * ((4 * 3 * 2)));

    //     }

    // }
}

export default ShootGeometry;